import M from 'materialize-css';

const Toast = {
    show: (message: string) => {
        M.toast({
            html: `${message}`,
        });
    }
}

export default Toast;
